export const Context = {
  Home: "HOME",
  Model: "MODEL",
  Graph: "GRAPH",
  Metric: "METRIC",
  Analogy: "ANALOGY",
  Error: "ERROR"
}
